import { Challenge } from '../types/'

const isChallenge = (item: any): boolean => {
  return (item as Challenge).title !== undefined
}

export { isChallenge }
